import AppLoader from "./components/Loader";
import AppInput from "./components/Input";
import AppFile from "./components/File";
import AppTextarea from "./components/Textarea";
import AppSelect from "./components/Select";
import AppMultiSelect from "./components/MultiSelect";
import AppCheckbox from "./components/Checkbox";
import AppButton from "./components/Button";
import AppToggle from "./components/Toggle";
import AppCropImage from "./components/CropImage";
import AppRadioButtons from "./components/RadioButtons";
import AppLogin from "./views/Login";
import AppPasswordReset from "./views/PasswordReset";
import AppPasswordUpdate from "./views/PasswordUpdate";
import AppRegister from "./views/Register";
import CreateEvent from "./views/Event/Create/Index";
import PreviewEvent from "./views/Event/Preview/EventPreview";
import ManageEvents from "./views/Event/Manage/ManageEvents";
import EventSignups from "./views/Event/Manage/EventSignups";

export default function registerComponents(app) {
    // Inputs, Forms
    app.component("app-input", AppInput);
    app.component("app-file", AppFile);
    app.component("app-textarea", AppTextarea);
    app.component("app-select", AppSelect);
    app.component("app-checkbox", AppCheckbox);
    app.component("app-button", AppButton);
    app.component("app-toggle", AppToggle);
    app.component("app-radio-buttons", AppRadioButtons);
    app.component("app-loader", AppLoader);
    app.component("app-crop-image", AppCropImage);
    app.component("event-signups", EventSignups);

    // Auth
    app.component("app-login", AppLogin);
    app.component("app-password-reset", AppPasswordReset);
    app.component("app-password-update", AppPasswordUpdate);
    app.component("app-register", AppRegister);

    // Events
    app.component("app-create-event", CreateEvent);
    app.component("app-preview-event", PreviewEvent);
    app.component("app-manage-events", ManageEvents);
}
